import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "create-page" }
const _hoisted_2 = { class: "trip-header" }
const _hoisted_3 = { class: "trip-breadcrumb" }
const _hoisted_4 = { class: "breadcrumb-item" }
const _hoisted_5 = { class: "breadcrumb-item" }
const _hoisted_6 = { class: "breadcrumb-id" }
const _hoisted_7 = { class: "create-card" }
const _hoisted_8 = { class: "form-section status-header" }
const _hoisted_9 = { class: "status-left" }
const _hoisted_10 = {
  class: "section-title",
  style: {"margin-bottom":"0"}
}
const _hoisted_11 = {
  class: "status-description",
  style: {"margin-top":"8px"}
}
const _hoisted_12 = { class: "status-actions" }
const _hoisted_13 = { class: "form-section" }
const _hoisted_14 = { class: "section-title" }
const _hoisted_15 = { class: "form-section" }
const _hoisted_16 = { class: "section-title" }
const _hoisted_17 = { class: "form-section" }
const _hoisted_18 = { class: "section-title" }
const _hoisted_19 = { class: "section-hint" }
const _hoisted_20 = { class: "photo-grid" }
const _hoisted_21 = { class: "upload-box" }
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 1,
  class: "upload-art"
}
const _hoisted_24 = ["onChange"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "photo-caption" }
const _hoisted_27 = { class: "form-actions" }

import { ref, reactive, watch, onMounted } from 'vue'
import { Plus, Right, Delete, ArrowRight } from '@element-plus/icons-vue'
import type { GolfCarProfile } from '@/api/golf'
import { useGolfVehiclesStore } from '@/store/golf-vehicles'


export default /*@__PURE__*/_defineComponent({
  __name: 'GolfCarInfoSection',
  props: {
    profile: {}
  },
  emits: [
  'updateStatus',
  'updateProfile',
  'uploadImage',
  'deleteImage'
],
  setup(__props: any, { emit: __emit }) {

const props = __props
const getStatusType = (status: string) => {
  switch (status) {
    case 'active':
      return 'success'
    case 'inactive':
      return 'warning'
    case 'admin_blocked':
      return 'danger'
    default:
      return 'info'
  }
}

const emit = __emit

const golfStore = useGolfVehiclesStore()
const formRef = ref<any>(null)
const isLoading = ref(false)
const isUploading = reactive<Record<string, boolean>>({
  front: false,
  back: false,
  left: false,
  right: false
})

const formData = reactive({
  name: '',
  model_name: '',
  seats: 4,
  description: '',
  geo_zone_map_url: ''
})

const formRules = {
  name: [
    { required: true, message: 'Name is required', trigger: 'blur' },
    { min: 2, max: 100, message: 'Name must be between 2 and 100 characters', trigger: 'blur' },
  ],
  model_name: [
    { required: true, message: 'Model name is required', trigger: 'blur' },
    { min: 2, max: 100, message: 'Model name must be between 2 and 100 characters', trigger: 'blur' },
  ],
}

const initializeForm = () => {
  formData.name = props.profile.name || ''
  formData.model_name = props.profile.model_name || ''
  formData.seats = props.profile.seats || 4
  formData.description = props.profile.description || ''
  formData.geo_zone_map_url = props.profile.geo_zone_map_url || ''
}

watch(
  () => props.profile,
  () => {
    initializeForm()
  },
  { immediate: true }
)

const submitForm = async () => {
  if (!formRef.value) return
  await formRef.value.validate((valid: boolean) => {
    if (valid) {
      isLoading.value = true
      emit('updateProfile', { ...formData })
      setTimeout(() => {
        isLoading.value = false
      }, 500)
    }
  })
}

// Images Logic
const getImageUrl = (type: string) => {
  if (!props.profile.images) return ''
  const img = props.profile.images.find((i: any) => i.type === type)
  return img ? img.secure_url : ''
}

const onFileChange = (event: Event, type: string) => {
  isUploading[type] = true
  emit('uploadImage', event, type)
  setTimeout(() => {
    isUploading[type] = false
  }, 1000)
}

const onDeleteImage = (type: string) => {
  if (!props.profile.images) return
  const img = props.profile.images.find((i: any) => i.type === type)
  if (img) {
    emit('deleteImage', img.id)
  }
}

// Status Helpers
const formatStatus = (status: string) => {
  switch (status) {
    case 'active':
      return 'Active'
    case 'inactive':
      return 'Inactive'
    case 'admin_blocked':
      return 'Blocked'
    default:
      return status
  }
}

const getStatusClass = (status: string) => {
  switch (status) {
    case 'active':
      return 'status-active'
    case 'inactive':
      return 'status-inactive'
    case 'admin_blocked':
      return 'status-blocked'
    default:
      return ''
  }
}

const getStatusDescription = (status: string) => {
  switch (status) {
    case 'active':
      return 'Model is visible and available for reservations'
    case 'inactive':
      return 'Model is hidden and not available for new reservations'
    case 'admin_blocked':
      return 'Model has been blocked by an administrator'
    default:
      return ''
  }
}

onMounted(() => {
  if (!golfStore.profileTariffs.length) {
    golfStore.fetchTariffs()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.profile)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "#golf-header-portal"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('golf.fleet.title')), 1),
              _createVNode(_component_el_icon, { class: "breadcrumb-separator" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ArrowRight))
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('golf.fleet.car_details')), 1),
              _createVNode(_component_el_icon, { class: "breadcrumb-separator" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ArrowRight))
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.profile.name), 1),
              _createVNode(_component_el_tag, {
                type: getStatusType(_ctx.profile.status),
                effect: "light",
                class: "status-tag"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(formatStatus(_ctx.profile.status)), 1)
                ]),
                _: 1
              }, 8, ["type"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: formData,
        rules: formRules,
        "label-position": "top",
        onSubmit: _withModifiers(submitForm, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h3", _hoisted_10, [
                _createTextVNode(_toDisplayString(_ctx.$t('golf.common.status')) + ": ", 1),
                _createElementVNode("span", {
                  class: _normalizeClass(getStatusClass(_ctx.profile.status))
                }, _toDisplayString(formatStatus(_ctx.profile.status)), 3)
              ]),
              _createElementVNode("p", _hoisted_11, _toDisplayString(getStatusDescription(_ctx.profile.status)), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.profile.status === 'active')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "danger",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('updateStatus', 'inactive')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('golf.users.block')), 1)
                    ]),
                    _: 1
                  }))
                : (_ctx.profile.status === 'inactive')
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "success",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('updateStatus', 'active')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('golf.users.unblock')), 1)
                      ]),
                      _: 1
                    }))
                  : (_ctx.profile.status === 'admin_blocked')
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        type: "success",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('updateStatus', 'active')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('golf.users.unblock')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_el_divider),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.$t('golf.fleet.basic_info')), 1),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('golf.fleet.model_name'),
              prop: "name",
              class: "form-item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.name) = $event)),
                  placeholder: _ctx.$t('golf.fleet.eg_make_name'),
                  clearable: "",
                  maxlength: "100",
                  "show-word-limit": ""
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('golf.fleet.model_name'),
              prop: "model_name",
              class: "form-item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.model_name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.model_name) = $event)),
                  placeholder: _ctx.$t('golf.fleet.eg_model_seats'),
                  clearable: "",
                  maxlength: "100",
                  "show-word-limit": ""
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('golf.fleet.capacity'),
              prop: "seats",
              class: "form-item form-item-narrow"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: formData.seats,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.seats) = $event)),
                  min: 1,
                  max: 10,
                  "controls-position": "right"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.$t('golf.common.details')), 1),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('golf.common.details'),
              class: "form-item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.description,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.description) = $event)),
                  type: "textarea",
                  placeholder: _ctx.$t('golf.fleet.detailed_description_placeholder'),
                  rows: 4,
                  clearable: "",
                  maxlength: "500",
                  "show-word-limit": ""
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.$t('golf.fleet.profile_photo')), 1),
            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('golf.fleet.upload_images_hint')), 1),
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['front', 'back', 'left', 'right'], (type) => {
                return _createElementVNode("div", {
                  key: type,
                  class: "photo-slot"
                }, [
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (getImageUrl(type))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: getImageUrl(type),
                          class: "slot-img",
                          alt: "preview"
                        }, null, 8, _hoisted_22))
                      : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createVNode(_component_el_icon, { size: 32 }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Plus))
                            ]),
                            _: 1
                          })
                        ])),
                    _createElementVNode("input", {
                      class: "upload-input",
                      type: "file",
                      accept: "image/png,image/jpeg",
                      onChange: ($event: any) => (onFileChange($event, type))
                    }, null, 40, _hoisted_24),
                    (getImageUrl(type))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: "remove-button",
                          type: "button",
                          onClick: ($event: any) => (onDeleteImage(type))
                        }, " ✕ ", 8, _hoisted_25))
                      : _createCommentVNode("", true)
                  ])), [
                    [_directive_loading, isUploading[type]]
                  ]),
                  _createElementVNode("div", _hoisted_26, _toDisplayString(type.charAt(0).toUpperCase() + type.slice(1)), 1)
                ])
              }), 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_el_button, {
              class: "submit-btn",
              type: "warning",
              size: "large",
              loading: isLoading.value,
              onClick: submitForm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('golf.common.save_changes')) + " ", 1),
                _createVNode(_component_el_icon, { class: "submit-icon" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Right))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ])
  ]))
}
}

})